import React from 'react'
import { Remove } from '@mui/icons-material'
import { IconButton, Tooltip } from "@mui/material"
import LaunchIcon from "@mui/icons-material/Launch"
import CancelIcon from "@mui/icons-material/Cancel"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import RemoveIcon from "@mui/icons-material/Remove"
import Colors from "../../../utils/Colors"
import { formatInBrazilianDatetime } from "../../../utils/functions"
import styles from './styles'
import { TRANSLATED_INTERNAL_USER_ROLES } from "../../../utils/constants/userRoles"

const UserRow = (props) => {
  const { user, onClick } = props

  const classes = styles()

  const getIcon = (userDisabled) => {
    switch (userDisabled) {
      case true:
        return <CancelIcon style={{ color: Colors.red }} />
      case false:
        return <CheckCircleIcon style={{ color: Colors.green }} />
      default:
        return <RemoveIcon style={{ color: Colors.gray }} />
    }
  }

  return (
    <tr id={user?.uuid}>
      <td>
        {user.user_role === 'Onboarding Admin' ? <Remove fontSize='large' style={{ color: '#AAA' }} /> : user?.email}
      </td>
      <td>
        {user?.display_name}
      </td>
      <td>
        {TRANSLATED_INTERNAL_USER_ROLES[user?.user_role]}
      </td>
      <td>
        <div className={classes.userStatusRow}>
          {getIcon(user.disabled)} {user.disabled ? 'Inativo' : 'Ativo'}
        </div>
      </td>
      <td>
        {formatInBrazilianDatetime(user?.created)}
      </td>
      <td>
        {user?.validated_at ? formatInBrazilianDatetime(user?.validated_at) : <Remove style={{ color: '#AAA' }} />}
      </td>
      <td>
        <div>
          {user.user_role !== 'Onboarding Admin' ? (<Tooltip
            arrow
            placement="top"
            title={<b>
              Visualizar/Editar informações
            </b>}
          >
            <IconButton
              id={user.email}
              value={user}
              onClick={onClick}
              size="large"
              disabled={user.user_role === 'Onboarding Admin'}
            >
              <LaunchIcon
                style={{
                  color: Colors.primaryColor, fontSize: 20,
                }}
              />
            </IconButton>
          </Tooltip>) : <Remove fontSize='large' style={{ color: '#AAA' }} />}
        </div>
      </td>
    </tr>
  )
}

export default UserRow
